<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" class="border-bottom px-4">
    <button
      [cSidebarToggle]="sidebarId()"
      cHeaderToggler
      class="btn"
      toggle="visible"
      style="margin-inline-start: -14px;"
      aria-label="Toggle sidebar navigation"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="d-none d-md-flex">
      <c-nav-item>
        <ng-container *ngIf="(cashierStatus$ | async) as status">
          <div class="me-3">
            <strong>Caixa:</strong>
            <span [ngClass]="{'text-success': status.isOpen, 'text-danger': !status.isOpen}">
              {{ status.isOpen ? 'ABERTO' : 'FECHADO' }}
            </span>
          </div>
          <div *ngIf="status.isOpen">
            <strong>Aberto em: </strong>
            <span>{{ status.openingDate }}</span>
          </div>
        </ng-container>
      </c-nav-item>
    </c-header-nav>

    <!-- <c-header-nav class="d-none d-md-flex ms-auto ">
      <a cNavLink>
        <svg cIcon class="my-1" name="cilBell" size="lg"></svg>
      </a>
      <a cNavLink>
        <svg cIcon class="my-1" name="cilList" size="lg"></svg>
      </a>
      <a cNavLink>
        <svg cIcon class="my-1" name="cilEnvelopeOpen" size="lg"></svg>
      </a>
    </c-header-nav> -->

    <a cNavLink
      class="ms-2"
      (click)="toggleCashier()"
      [ngClass]="{'text-success': (cashierStatus$ | async)?.isOpen, 'text-danger': !(cashierStatus$ | async)?.isOpen}">
      <svg cIcon
          [name]="(cashierStatus$ | async)?.isOpen ? 'cil-lock-unlocked' : 'cil-lock-locked'"
          size="lg"></svg>
      {{ (cashierStatus$ | async)?.isOpen ? 'Fechar Caixa' : 'Abrir Caixa' }}
    </a>

    <c-header-nav class="d-none d-md-flex ms-auto">
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
      <ng-container *ngTemplateOutlet="themeDropdown" />
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
    </c-header-nav>

    <c-header-nav class="mx-0">
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>

  </c-container>
  <c-container [fluid]="true" class="px-4">
    <c-breadcrumb-router />
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-start' }" variant="nav-item">
    <button [caret]="false" cDropdownToggle class="py-0 pe-0" aria-label="Open user menu">
      <c-avatar
        shape="rounded-1"
        [size]="'md'"
        src="./assets/images/avatars/8.png"
        status="success"
        textColor="primary"
        alt="User avatar"
      />
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold py-2 rounded-top">
          Usuário
        </h6>
      </li>
      <li>
        <div class="px-3 py-2">
          <div><strong>Nome:</strong> {{ currentEmployee?.nameEmployee }}</div>
          <!-- <div><strong>Função:</strong> {{ currentEmployee?.role }}</div> -->
        </div>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a cDropdownItem (click)="alterPassword(null)">
          <svg cIcon class="me-2" name="cilUser"></svg>
          Meu usuário
        </a>
      </li>
      <li>
        <a cDropdownItem (click)="logout()">
          <svg cIcon class="me-2" name="cilAccountLogout"></svg>
          Sair
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle aria-label="Open theme picker">
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
        <button
          (click)="colorMode.set(mode.name)"
          [active]="colorMode()===mode.name"
          cDropdownItem
          class="d-flex align-items-center"
        >
          <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
          {{ mode.text }}
        </button>
      }
    </div>
  </c-dropdown>
</ng-template>

<!-- Modal de Confirmação de Fchamento de Caixa -->
<app-custom-modal
  [visible]="modalCloseCashier"
  (visibleChange)="modalCloseCashier = $event"
  [title]="modalCloseCashierTitle"
  [description]="modalCloseCashierDescription"
  [primaryButtonText]="'Confirmar Fechamento'"
  [secondaryButtonText]="'Voltar'"
  (primaryAction)="closeCashier()">
</app-custom-modal>

<app-custom-modal
  [(visible)]="modalOpenCashier"
  [title]="'Confirmação'"
  [description]="'Deseja realmente realizar esta ação?'"
  [fields]="modalFieldsOpenCashier"
  [primaryButtonText]="'Confirmar'"
  [secondaryButtonText]="'Cancelar'"
  (primaryAction)="openCashier($event)">
</app-custom-modal>

<app-custom-modal
  [(visible)]="modalAlterPassword"
  [title]="'Alteração de Senha'"
  [description]="'Para alterar sua senha, informe a senha atual e a nova.'"
  [fields]="modalFieldsAlterPassword"
  [primaryButtonText]="'Confirmar'"
  [secondaryButtonText]="'Cancelar'"
  (primaryAction)="alterPassword($event)">
</app-custom-modal>

<app-cashier-summary-modal
  [visible]="summaryModalVisible"
  [summaryData]="summaryData"
  (visibleChange)="summaryModalVisible = $event"
  [extraButtonVisible]="true"
  [extraButtonText]="'Fechar Caixa'"
  (extraButtonClick)="closeCashier()">
</app-cashier-summary-modal>
